import { Output, EventEmitter } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { GraphqlService } from '../../services/graphql.service';
import { CommonDataService } from '../../services/common-data.service';
import { LoginService } from '../../services/Login.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { constObj } from '../../Constants/constants';
import { HttpcallService } from '../../services/httpcall.service';

@Component({
  selector: 'app-bookmark',
  templateUrl: './bookmark.component.html'
})
export class BookmarkComponent implements OnInit {
  @Output() myEvent = new EventEmitter<string>();
  addBookmarkLabel: any;
  bookmarkingLabel: any;
  addBookmarktitle: any;
  cancelButtonLabel: any;
  bookmarksubmit: any;
  emailId: string;
  currentParagraph: string;
  currentParagraphId: string;
  todayDate: Date = new Date();

  constructor(private graphQlService: GraphqlService, private loginService: LoginService,
    private httpCallService: HttpcallService,
    public commonDataService: CommonDataService, private datePipe: DatePipe,private router:Router) {
  }

  pageUrl:string = "";
  bookmarkTitle = new FormControl('');
  bookmarkBreadcrumbPath: string = "";
  pageNums: string = "";
  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.commonDataService.currentParagraph.subscribe(data1 => {
      this.currentParagraph = data1;
    });
    this.commonDataService.currentParagraphId.subscribe(data2 => {
      this.currentParagraphId = data2;
    });
    this.commonDataService.pageUrl.subscribe(data3 => { this.pageUrl = data3; })
    this.commonDataService.breadcrumbPath.subscribe(path => {
      this.breadcrumbPath = path;
      this.pageNums = "";
      let crumbData = this.breadcrumbPath.split("~");
      this.bookmarkBreadcrumbPath = crumbData[0] + "~";
      for (let i = 1; i < crumbData.length; i++) {
        if (!crumbData[i].split(" ")[0].includes("X")) {
          this.pageNums += (i != crumbData.length - 1 ? crumbData[i].split(" ")[0] + "-" : crumbData[i].split(" ")[0]);
          this.bookmarkBreadcrumbPath += (i != crumbData.length - 1 ? crumbData[i] + "~" : crumbData[i])
        }
      }
    });
    this.getbookmarkLabel();

    this.commonDataService.emailId.subscribe(userData => this.emailId = userData);
  }

  closeOverlay() {
    this.myEvent.emit();
    this.commonDataService.showLoader.next(false);
  }
  getbookmarkLabel() {
    this.graphQlService.getGlobalLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.addBookmarkLabel = labels.filter(x => x.key == "addBookmark_header").map(y => y.value);
        this.bookmarkingLabel = labels.filter(x => x.key == "addBookmark_subtext").map(y => y.value);
        this.addBookmarktitle = labels.filter(x => x.key == "addBookmark_title").map(y => y.value);
        this.cancelButtonLabel = labels.filter(x => x.key == "global_cancel").map(y => y.value);
        this.bookmarksubmit = labels.filter(x => x.key == "global_add").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    });
  }

  breadcrumbPath: string = "";
  Submit() {
    this.commonDataService.showLoader.next(true);
    var url="";
    if ((!this.router.url?.includes("showallinonepage")) && (!this.router.url?.includes("showallinonepageplus"))) {
     url = "/"+this.router.url?.split("/")[1] + "/" + this.router.url?.split("/")[2] + "/" + this.currentParagraph;
    }
    if (this.bookmarkBreadcrumbPath !== "") {
          var bookmark = {
            ID: '-1', TopicId: 'topic1', ParagraphId: this.currentParagraphId, BookmarkTitle: this.bookmarkTitle.value, BookMarkBreadCrumb: this.bookmarkBreadcrumbPath + "~" + this.currentParagraph, IsDeleted: false, CreatedOn: "", ModifiedOn: "", ApplicationSource: "FASB",
            BookmarkURL: this.router.url?.includes("showallinonepage") || this.router.url?.includes("showallinonepageplus") ? "/" + this.pageUrl+"/"+this.currentParagraph : url, NavigationPath: this.pageNums
            }
            this.httpCall(bookmark)
        }
  }
  httpCall(bookmark) {
    this.httpCallService.addUpdateBookmark(bookmark).toPromise()
      .then(response => {
        if (response == "Bookmark added successfully") {
          this.commonDataService.addBookmarkParagraphId.next(bookmark.ParagraphId);
          let obj = {
            type: 'success',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.bookmarkAddedMessage
          }
          this.commonDataService.notificationObject.next(obj);
          this.closeOverlay();
        }
        else if (response == "Session expired") {
          let obj = {
            type: 'error',
            displayTime: 3000,
            position: 'bottom',
            message: "You are not authorized , please log in"
          }
          this.commonDataService.notificationObject.next(obj);
          this.closeOverlay();
          this.router.navigate(['Login'])
        }
        else {
          let obj = {
            type: 'error',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.bookmarkAddedFailMessage
          }
          this.commonDataService.notificationObject.next(obj);
          this.closeOverlay();
        }
      })
      .catch(res => {
        console.log(res);
        this.commonDataService.showLoader.next(false);
      });
  }


  remainingText: number = 0;
  
  BookMarkTitleModified(value: string) {
    this.remainingText = 100 - value.length;
  }
}
